var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 49,
    viewBox: "0 0 58 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62299 22.4486L5.17251 45.1933C5.40755 46.6994 6.819 47.7298 8.32508 47.4947L46.1374 41.5937C47.6435 41.3587 48.6739 39.9472 48.4388 38.4412L44.8893 15.6965C44.6543 14.1904 43.2428 13.16 41.7367 13.3951L3.9244 19.296C2.41833 19.5311 1.38795 20.9425 1.62299 22.4486Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4733 19.4347L2.20697 26.1868L2.85304 30.3267L46.1193 23.5746L45.4733 19.4347Z",
    fill: "#2E63EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.63 31.34C40.4971 31.34 41.2 30.6371 41.2 29.77C41.2 28.9029 40.4971 28.2 39.63 28.2C38.7629 28.2 38.06 28.9029 38.06 29.77C38.06 30.6371 38.7629 31.34 39.63 31.34Z",
    fill: "#00C9B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.43 33.24C28.2971 33.24 29 32.5371 29 31.67C29 30.8029 28.2971 30.1 27.43 30.1C26.5629 30.1 25.86 30.8029 25.86 31.67C25.86 32.5371 26.5629 33.24 27.43 33.24Z",
    fill: "#00C9B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.98 35.03C16.8471 35.03 17.55 34.3271 17.55 33.46C17.55 32.5929 16.8471 31.89 15.98 31.89C15.1129 31.89 14.41 32.5929 14.41 33.46C14.41 34.3271 15.1129 35.03 15.98 35.03Z",
    fill: "#00C9B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 29.67L32.77 31.76",
    stroke: "#00C9B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.48 29.95L34.58 31.48",
    stroke: "#00C9B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.02 33.3L9.48999 35.4",
    stroke: "#00C9B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21002 33.58L11.31 35.11",
    stroke: "#00C9B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.51 31.28L21.91 33.84",
    stroke: "#00C9B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.43 32.76L22.99 32.36",
    stroke: "#00C9B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.28 4.68V1",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.24 8.07002L52.6 5.71002",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 14.82H56.93",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethods);
export default __webpack_public_path__ + "static/media/payment-methods.3300839e55e1f118b53daa1c138e2a1f.svg";
export { ForwardRef as ReactComponent };